import { useSelector } from 'react-redux'
import { useFirestoreConnect, useFirebase } from 'react-redux-firebase'
import { ITEM_COLLECTION } from '../../modules/firebase/collections'

export function useItem(id = null) {
    const firebase = useFirebase()

    const addItem = firebase.functions().httpsCallable('addItem')
    const saveStep = firebase.functions().httpsCallable('saveStep')
    const registerStatus = firebase.functions().httpsCallable('registerStatus')
    const registerItem = firebase.functions().httpsCallable('registerItem')
    const transfer = firebase.functions().httpsCallable('transfer')

    const createItem = async ({ step }) => {
        const { data: { id: itemId } } = await addItem({ step })
        return itemId
    }

    const saveStepAndRegisterItem = async ({ itemId, stepId, step }) => {
        await saveStep({ itemId, step })
        await registerItem({ itemId, stepId })
    }

    const saveStepAndRegisterStatus = async ({ itemId, stepId, step }) => {
        await saveStep({ itemId, step })
        await registerStatus({ itemId, stepId })
    }

    const saveStepAndTransfer = async ({ itemId, stepId, step }) => {
        await saveStep({ itemId, step })
        await transfer({ itemId, stepId })
    }

    const nextStepMap = {
        production_fundicao: createItem,
        production_usinagem: saveStepAndRegisterItem,
        quality: saveStepAndRegisterStatus,
        stock: saveStepAndRegisterStatus,
        sales: saveStepAndRegisterStatus,
        delivery: saveStepAndTransfer
    }

    const handleNextStep = stepId => nextStepMap[stepId]

    useFirestoreConnect([{ collection: ITEM_COLLECTION }])
    const data = useSelector(({ firestore: { data } }) => data[ITEM_COLLECTION] && data[ITEM_COLLECTION][id])

    return {
        all: useSelector(({ firestore: { ordered } }) => ordered[ITEM_COLLECTION]),
        item: data,
        addItem: firebase.functions().httpsCallable('addItem'),
        nextStep: stepId => handleNextStep(stepId),
    }
}
